import React from 'react';
import AboutMeEditor from './AboutMeEditor';
import ReadingListCard from '../common/ReadingListCard';
import ContactInfoCard from '../common/ContactInfoCard';

const AboutPage = ({ isAdmin, setMessage }) => (
  <div className="grid lg:grid-cols-3 gap-10">
    {/* Main Content */}
    <div className="lg:col-span-2">
      <AboutMeEditor isAdmin={isAdmin} setMessage={setMessage} />
    </div>
    
    {/* Sidebar */}
    <aside className="lg:col-span-1 space-y-6">
      <ContactInfoCard isAdmin={isAdmin} setMessage={setMessage} />
      <ReadingListCard isAdmin={isAdmin} setMessage={setMessage} />
    </aside>
  </div>
);

export default AboutPage;
